import { render, staticRenderFns } from "./UserActivationModal.vue?vue&type=template&id=c64d4bd8&"
import script from "./UserActivationModal.vue?vue&type=script&lang=js&"
export * from "./UserActivationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports